import React, { useEffect, useState } from 'react'
import seqStore from '../../store/seqStore'

export default function MelodyIcon() {
    const currentTrack = seqStore((state) => state.settings.currentTrack)

    const [fillColour, setFillColour] = useState('#FFB72C')

    useEffect(() =>{
        switch(currentTrack) {
            case 0:
                setFillColour('#FFB72C')
                break
            case 1:
                setFillColour('#FC4B4B')
                break
            case 2:
                setFillColour('#47BE61')
                break
            case 3:
                setFillColour('#1A8DF8')
                break
            default: setFillColour('#FFB72C')
        }
    }, [currentTrack])

    return (
        <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.84198 0C7.84198 0.706616 8.15772 1.39245 8.78919 2.0575C9.42065 2.72255 10.0387 3.43609 10.6433 4.19813C11.2479 4.97402 11.6711 5.83305 11.9129 6.7752C12.1548 7.7035 11.8928 8.79113 11.127 10.0381C10.8986 10.3845 10.7306 10.523 10.6231 10.4538C10.5291 10.3706 10.5156 10.2321 10.5828 10.0381C10.6634 9.77485 10.7037 9.37305 10.7037 8.8327C10.7037 8.29235 10.6097 7.73814 10.4216 7.17007C10.2469 6.60201 9.95136 6.08937 9.53486 5.63214C9.13179 5.16107 8.5675 4.86318 7.84198 4.73848V16.1275C7.84198 16.4739 7.77481 16.8202 7.64045 17.1666C7.5061 17.513 7.31128 17.8455 7.05601 18.1642C6.80073 18.4829 6.49172 18.7669 6.12896 19.0163C5.77963 19.2795 5.37657 19.4943 4.91976 19.6605C4.40921 19.8545 3.89195 19.9654 3.36796 19.9931C2.85741 20.0208 2.38717 19.9654 1.95724 19.8268C1.5273 19.7021 1.15111 19.5012 0.828654 19.2241C0.506202 18.9609 0.277799 18.6353 0.143444 18.2473C-0.00434678 17.8455 -0.0379355 17.4368 0.0426775 17.0211C0.12329 16.6055 0.284516 16.2037 0.526355 15.8157C0.78163 15.4278 1.1108 15.0745 1.51386 14.7558C1.93036 14.4233 2.40061 14.16 2.92459 13.9661C3.50232 13.7444 4.07333 13.6335 4.63762 13.6335C5.21534 13.6335 5.73261 13.7236 6.18942 13.9037V0H7.84198Z" fill={fillColour}/>
        </svg>

    )
}
